var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectAndTeamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 2.375C6.82291 2.375 8.25 3.80209 8.25 5.5625V8.75H5.0625C3.30209 8.75 1.875 7.32291 1.875 5.5625C1.875 3.80209 3.30209 2.375 5.0625 2.375ZM5.0625 10.25H8.25V13.4375C8.25 15.1979 6.82291 16.625 5.0625 16.625C3.30209 16.625 1.875 15.1979 1.875 13.4375C1.875 11.6771 3.30209 10.25 5.0625 10.25ZM12.9375 2.375C14.6979 2.375 16.125 3.80209 16.125 5.5625C16.125 7.32291 14.6979 8.75 12.9375 8.75H9.75V5.5625C9.75 3.80209 11.1771 2.375 12.9375 2.375ZM9.75 10.25H12.9375C14.6979 10.25 16.125 11.6771 16.125 13.4375C16.125 15.1979 14.6979 16.625 12.9375 16.625C11.1771 16.625 9.75 15.1979 9.75 13.4375V10.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectAndTeamIcon);
export default __webpack_public_path__ + "static/media/projectAndTeamIcon.a4a95cb4.svg";
export { ForwardRef as ReactComponent };